import jiangshun from "./index.vue";
import jiangshunHome from "./Home.vue";

const bridgeImg = () => import("./bridgeImg.vue");
// const emptyComponent = () => import("./emptyRouterComponent.vue");
const gasClamp = () => import("./gasClamp.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");

export default [
    {
        path: "/jiangshunIndex",
        name: "jiangshunIndex",
        component: jiangshunHome
    },
    {
        path: "/jiangshun/login",
        name: "jiangshunLogin",
        component: login
    },
    {
        path: "/jiangshun",
        name: "jiangshun",
        redirect: "/jiangshun",
        component: jiangshun,
        children: [
            {
                path: "currentDataTable",
                name: "currentDataTable",
                component: simpleCurrentData,
            },
            {
                path: 'gasClamp',
                name: 'jiangshunGasClamp',
                component: gasClamp
            },
            {
                path: 'bridgeImg',
                name: 'jiangshunBridgeImg',
                component: bridgeImg
            },
            {
                path: "dataHistory",
                name: "dataHistory",
                component: dataHistory
            },
        ]
    }
];
